import type { BoxSlotSessionApiGateway } from "@/modules/boxSlotSession/gateway/boxSlotSessionApiGateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import {
  BoxSessionDetailsDtoSchema,
  type BoxSessionCreateInputDto,
  type BoxSessionDetailsDto,
  type BoxSessionUpdateInputDto,
} from "@/modules/boxSlotSession/gateway/boxSlotSessionDto"
import type { ApiClient } from "@/modules/core/api/client/apiClient"

export class BoxSlotSessionApi implements BoxSlotSessionApiGateway {
  private sessionBaseUrl = "/box/sessions"

  constructor(private readonly api: ApiClient) {}

  async getSessionDetails(id: string): Promise<BoxSessionDetailsDto> {
    const resultDto = await this.api.get<BoxSessionDetailsDto>(`${this.sessionBaseUrl}/${id}`)
    return LoggerService.parseApiDto(BoxSessionDetailsDtoSchema, resultDto.data)
  }

  async createSession(sessionDraft: BoxSessionCreateInputDto) {
    const sessionDto = await this.api.post<BoxSessionDetailsDto>(this.sessionBaseUrl, sessionDraft)
    return LoggerService.parseApiDto(BoxSessionDetailsDtoSchema, sessionDto.data)
  }

  async updateSession(id: string, sessionDraft: BoxSessionUpdateInputDto) {
    const resultDto = await this.api.put<BoxSessionDetailsDto>(`${this.sessionBaseUrl}/${id}`, sessionDraft)
    return LoggerService.parseApiDto(BoxSessionDetailsDtoSchema, resultDto.data)
  }

  async deleteSession(id: string) {
    await this.api.delete(`${this.sessionBaseUrl}/${id}`)
  }
}
